module.exports = __webpack_public_path__ + "assets/img/returnBtn-5a734734.png";